import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  UpdateReferralRequestDocument,
  UpdateReferralRequestInput,
  UpdateReferralRequestMutation,
  UpdateReferralRequestMutationVariables,
} from '../generated/referral-request';

const useUpdateReferralRequest = () => {
  const [{ data, fetching, errorMessage }, executeMutation] = useSecureGraphqlMutation<
    UpdateReferralRequestMutation,
    UpdateReferralRequestMutationVariables
  >(UpdateReferralRequestDocument);

  const updateReferralRequest = (input: UpdateReferralRequestInput) => executeMutation({ input });
  const result = data?.updateReferralRequest;

  return { errorMessage, fetching, result, submitted: Boolean(result), updateReferralRequest };
};

export { useUpdateReferralRequest };
